module.exports = __webpack_public_path__ + "img/info-bg02.d542560c.png";